import {
  deliveryAdviceCharges,
  deliveryAdviceCostCharges
} from "@/utils/constants";
import {
  handleError,
  handleResponse
} from "@/utils/functions";

export default (axios) => ({
  getDeliveryAdviceChargesList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(deliveryAdviceCharges.deliveryAdviceChargesBase, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },

  getDeliveryAdviceChargesDetails(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${deliveryAdviceCharges.deliveryAdviceChargesBase}${id}/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },

  addDeliveryAdviceCharge(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(deliveryAdviceCharges.deliveryAdviceChargesBase, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  
 

  updateDeliveryAdviceCharge(payload) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${deliveryAdviceCharges.deliveryAdviceChargesBase}${payload.id}/`, payload.data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },

  deleteDeliveryCharge(id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${deliveryAdviceCharges.deliveryAdviceChargesBase}${id}/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },

  // Cost Charges API
   addDeliveryAdviceCostCharge(data) {
    return new Promise((resolve, reject) => {
      axios
      .post(`${deliveryAdviceCostCharges.deliveryAdviceCostChargesBase}`, data)
        
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  updateDeliveryAdviceCostCharge(payload) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${deliveryAdviceCostCharges.deliveryAdviceCostChargesBase}${payload.id}/`, payload.data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getDeliveryAdviceCostChargesList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(deliveryAdviceCostCharges.deliveryAdviceCostChargesBase, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getDeliveryAdviceCostChargesDetails(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${deliveryAdviceCostCharges.deliveryAdviceCostChargesBase}${id}/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  deleteCostDeliveryCharge(id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${deliveryAdviceCostCharges.deliveryAdviceCostChargesBase}${id}/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },

});